var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 364,
    height: 71.758,
    viewBox: "0 0 364 71.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(0 0.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M31.049,0,62.1,17.936V53.812L55.07,57.869l-.052-36.238L31.044,7.391,20.331,13.811,20.31,6.2,31.049-.01Zm2.007,36.039,12.306,7v12.82l-14.314,8.5L7.076,50.112V13.843L0,17.936V53.812L31.049,71.748l20.43-11.8V24.126L33.057,13.612v7.851l12.306,7v6.745L33.057,28.183v7.851ZM10.98,5.436,17.039,1.3l.047,19.822,11.971-7.107L29,58.378,10.839,47.7,10.98,5.441Zm5.75,22.653,6.185-3.265-.073,22.045-6.111-3.25V28.094Z",
    fill: "#ff6b00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M154.306,33.5a27.877,27.877,0,0,1,7.5.812,6.69,6.69,0,0,1,4.051,2.851,10.976,10.976,0,0,1,1.253,5.75,9.813,9.813,0,0,1-1.489,5.881,6.466,6.466,0,0,1-4.89,2.327v.314c2.788.246,4.738,1.174,5.854,2.8a11.814,11.814,0,0,1,1.672,6.772,10.809,10.809,0,0,1-1.279,5.75,6.8,6.8,0,0,1-3.973,2.851,25.048,25.048,0,0,1-7.034.812q-3.506,0-6.09-.026c-1.724-.016-3.318-.063-4.785-.131s-2.961-.157-4.5-.262l.786-5.54c.839.037,2.448.068,4.838.1s5.168.052,8.339.052a11.322,11.322,0,0,0,3.449-.419,2.756,2.756,0,0,0,1.751-1.541,8.221,8.221,0,0,0,.5-3.213,8.679,8.679,0,0,0-.524-3.423,3,3,0,0,0-1.8-1.646,11.362,11.362,0,0,0-3.527-.524H141.334V48.778H154.3a11.133,11.133,0,0,0,3.056-.419,2.528,2.528,0,0,0,1.593-1.41,7.3,7.3,0,0,0,.472-2.93,6.974,6.974,0,0,0-.5-2.956,2.62,2.62,0,0,0-1.7-1.384,11.905,11.905,0,0,0-3.344-.367h-5.173q-2.249,0-4.025.026c-1.185.016-2.285.063-3.292.131l-.786-5.54q2.091-.212,4.051-.288t4.261-.1q2.3-.024,5.383-.026Zm-5.854.419V69.99H140.61V33.919Z",
    transform: "translate(-66.908 -15.947)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1",
    d: "M212.5,34.3V70.37H204.55V34.3Z",
    transform: "translate(-97.34 -16.327)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2",
    d: "M247.944,40.207l8.784.052-17.406,24.2-8.837-.052,17.459-24.2Zm9.2,24.2V70.37H230.48V64.411ZM256.723,34.3v5.959H230.9V34.3Z",
    transform: "translate(-109.68 -16.327)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_3",
    d: "M299.614,34q2.767,0,5.671.026t5.7.157q2.8.134,5.2.393l-.419,5.75H302.7a3.025,3.025,0,0,0-2.144.681,2.579,2.579,0,0,0-.734,1.986V70.233h-8V41.374a6.989,6.989,0,0,1,2.144-5.357,7.918,7.918,0,0,1,5.645-2.013Zm-6.85,15.268h21.07v5.645h-21.07Z",
    transform: "translate(-138.87 -16.184)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_4",
    d: "M376.2,34.3V55.994a23.661,23.661,0,0,1-1.357,8.811,8.854,8.854,0,0,1-4.471,4.811,19.342,19.342,0,0,1-8.286,1.489,21.655,21.655,0,0,1-8.784-1.489,9.145,9.145,0,0,1-4.759-4.811,22.143,22.143,0,0,1-1.462-8.811V34.3h8V55.994a18.277,18.277,0,0,0,.6,5.3,4.364,4.364,0,0,0,2.065,2.694,8.315,8.315,0,0,0,3.92.786,8.144,8.144,0,0,0,3.894-.786A4.386,4.386,0,0,0,367.6,61.3a18.485,18.485,0,0,0,.6-5.3V34.3h8Z",
    transform: "translate(-165.166 -16.327)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_5",
    d: "M429.641,34.3V70.37H421.7l-.052-36.07Zm10.876,0v6.274h-29.7V34.3Z",
    transform: "translate(-195.499 -16.327)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_6",
    d: "M504.67,34.3V55.994a23.659,23.659,0,0,1-1.358,8.811,8.854,8.854,0,0,1-4.471,4.811,19.342,19.342,0,0,1-8.286,1.489,21.655,21.655,0,0,1-8.784-1.489,9.145,9.145,0,0,1-4.759-4.811,22.144,22.144,0,0,1-1.462-8.811V34.3h8V55.994a18.276,18.276,0,0,0,.6,5.3,4.364,4.364,0,0,0,2.065,2.694,8.316,8.316,0,0,0,3.92.786,8.144,8.144,0,0,0,3.894-.786,4.386,4.386,0,0,0,2.039-2.694,18.483,18.483,0,0,0,.6-5.3V34.3h8Z",
    transform: "translate(-226.302 -16.327)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_7",
    d: "M558.371,33.3a25.332,25.332,0,0,1,7.71.97,7.537,7.537,0,0,1,4.34,3.292,12.654,12.654,0,0,1,1.384,6.457,13.657,13.657,0,0,1-.655,4.418,6.267,6.267,0,0,1-2.17,3.056,8.408,8.408,0,0,1-4.13,1.462v.262a6.069,6.069,0,0,1,1.96.734,6.57,6.57,0,0,1,1.908,1.7,7.352,7.352,0,0,1,1.305,3.008L573.156,69.9h-8.417l-2.773-10.98a4.371,4.371,0,0,0-1.384-2.458,4.192,4.192,0,0,0-2.537-.681q-3.553,0-5.985-.026c-1.62-.016-2.982-.042-4.078-.079s-2.081-.068-2.956-.1l.157-5.8H558.2a9.949,9.949,0,0,0,3.318-.446,2.854,2.854,0,0,0,1.724-1.593,8.255,8.255,0,0,0,.5-3.187,8.221,8.221,0,0,0-.5-3.213,2.844,2.844,0,0,0-1.724-1.567,9.949,9.949,0,0,0-3.318-.446q-4.914,0-8.313.052t-4.654.157l-.786-5.7q2.194-.259,4.13-.367c1.289-.068,2.7-.115,4.235-.131s3.381-.026,5.54-.026Zm-6.012.524v36.07h-7.893V33.824h7.893Z",
    transform: "translate(-259.09 -15.851)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_8",
    d: "M617.056,34.3V70.37H609.11V34.3Z",
    transform: "translate(-289.86 -16.327)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_9",
    d: "M664.2,34.3l-8.889,17.563,9.565,18.507h-8.155l-8.994-18.507L656.087,34.3h8.1Zm-23.161,0L649.4,51.863,640.405,70.37H632.25l9.513-18.507L632.926,34.3h8.1Zm11.394,15.006v4.916h-8.208V49.306Z",
    transform: "translate(-300.872 -16.327)",
    fill: "#e0e0e0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d77e5fae4e372ad9a1d65dd5c50cb8d4.svg";
export { ForwardRef as ReactComponent };